import {IconProps} from "../../types/IconProps";

export const BarcodeIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg width={`${width}px`} height={`${width}px`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 8L8 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8L12 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 8L16 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.976 21C4.05476 21 3 19.9453 3 15.024" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M20.9999 15.024C20.9999 19.9453 19.9452 21 15.0239 21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M15.0239 3C19.9452 3 20.9999 4.05476 20.9999 8.976" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M3 8.976C3 4.05476 4.05476 3 8.976 3" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    )
}